import { AssetItem } from '@/entities/interwills';
import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';

const categorySortOrder: AssetCategory[] = [
  AssetCategory.RESIDENTIAL_REAL_ESTATE,
  AssetCategory.COMMERCIAL_REAL_ESTATE,
  AssetCategory.LAND,
  AssetCategory.DEBIT_ACCOUNTS,
  AssetCategory.METAL_ACCOUNTS,
  AssetCategory.BANK_CELLS,
  AssetCategory.BROKERAGE_ACCOUNT,
  AssetCategory.SECURITIES_AND_STOCKS,
  AssetCategory.BONDS,
  AssetCategory.FUTURES,
  AssetCategory.EXCHANGE_OPTIONS,
  AssetCategory.PUBLIC_FUND,
  AssetCategory.MY_FUND,
  AssetCategory.LEGAL_ENTITIES,
  AssetCategory.COMMODITY_ASSET_TOKENS,
  AssetCategory.OVER_THE_COUNTER_OPTIONS,
  AssetCategory.FORWARDS,
  AssetCategory.CENTRALIZED_WALLET,
  AssetCategory.DECENTRALIZED_WALLET,
  AssetCategory.JEWELLERY,
  AssetCategory.PRECIOUS_STONES,
];

export const sortAssets = (assets: AssetItem[]) => {
  return assets.slice().sort((a, b) => {
    const indexA = categorySortOrder.indexOf(a.category);
    const indexB = categorySortOrder.indexOf(b.category);

    const finalIndexA = indexA === -1 ? Infinity : indexA;
    const finalIndexB = indexB === -1 ? Infinity : indexB;

    return finalIndexA - finalIndexB;
  });
};
